<mat-card class="cardWithShadow">
  <mat-card-content class="p-24">

    <div class="table-responsive m-t-30">
      <table mat-table [dataSource]="dataSource" class="w-100" matSort  matSortDirection="desc" matSortActive="sellInvoiceTotalAmount">
        <!-- Position Column -->
        <ng-container matColumnDef="debtorName">
          <th mat-header-cell mat-sort-header *matHeaderCellDef class="th-title">
            Razon Social
          </th>
          <td mat-cell *matCellDef="let element" class="td-text-content  cell-4">
            <h6 matTooltip={{element.debtorName}}>
              {{ element.debtorName }}
            </h6>
          </td>
          <td mat-footer-cell *matFooterCellDef class="text-footer">
            Total
          </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="debtorRut">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">
            Rut
          </th>
          <td mat-cell *matCellDef="let element" class="td-text-content">
            <span>
              {{ element.debtorRut }}
            </span>
          </td>
          <td mat-footer-cell *matFooterCellDef class="td-text-content">
          </td>
        </ng-container>
        <ng-container matColumnDef="sellInvoiceTotalAmount">
          <th  mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">
            Ventas
          </th>
          <td mat-cell *matCellDef="let element" class="td-text-content">
            <span>
              {{ element.sellInvoiceTotalAmount | currency:'CLP':'symbol' }}
            </span>
          </td>
          <td mat-footer-cell *matFooterCellDef class="text-footer text-center">
            {{ calculateSellTotalAmount() | currency:'CLP':'symbol' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="buyInvoiceTotalAmount">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">
            Compras
          </th>
          <td mat-cell *matCellDef="let element" class="td-text-content">
            <span>${{ element.buyInvoiceTotalAmount | number }}</span>
          </td>
          <td mat-footer-cell *matFooterCellDef class="text-footer text-center">{{ calculateBuyTotalAmount() | currency:'CLP':'symbol' }}
          </td>
        </ng-container>



        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns">
        </tr>
        <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
        <!-- <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>   -->
        <!-- Row shown when there is no matching data. -->
        <!-- <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">
                  No data matching the filter "{{ input.value }}"
                </td>
              </tr> -->
      </table>
      <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>
  </mat-card-content>
</mat-card>